/**
 * Utility functions for detecting changes to keyed text keys
 */

/**
 * Extracts the key portion (text before and including first colon) from text
 * @param text - The full text to parse
 * @returns The key portion including the colon, or empty string if no colon found
 */
export const extractKey = (text: string): string => {
    const colonIndex = text.indexOf(':')
    if (colonIndex === -1) return ''
    return text.substring(0, colonIndex + 1)
}

/**
 * Checks if the key portion of text has changed
 * @param originalText - The original text
 * @param newText - The new text to compare
 * @returns true if the key has changed, false otherwise
 */
export const hasKeyChanged = (originalText: string, newText: string): boolean => {
    const originalKey = extractKey(originalText)
    const newKey = extractKey(newText)

    // If either text has no key, consider it not a key change
    if (!originalKey || !newKey) return false

    return originalKey.trim() !== newKey.trim()
}

/**
 * Checks if text contains a key (has a colon)
 * @param text - The text to check
 * @returns true if text contains a colon, false otherwise
 */
export const isKeyedText = (text: string): boolean => {
    return text.includes(':')
}
